import axios from "axios";
import { drawRoute } from "../../helper/form";

export const index = (filterRequestParams, callback) => {

  var promise = axios({
    method: 'get',
    url: Routes.corporate_agreements_path({ ...{...filterRequestParams }, format: "json", _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

